"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountMenuItemUrl = exports.AccountMenuItemIcon = exports.AccountMenuItemLabel = exports.AccountMenuItemId = void 0;
var AccountMenuItemId;

(function (AccountMenuItemId) {
  AccountMenuItemId["dashboard"] = "1";
  AccountMenuItemId["orders"] = "2";
  AccountMenuItemId["subscribeSave"] = "3";
  AccountMenuItemId["shoppingList"] = "4";
  AccountMenuItemId["quotes"] = "5";
  AccountMenuItemId["invoices"] = "6";
  AccountMenuItemId["myResources"] = "7";
  AccountMenuItemId["reports"] = "8";
  AccountMenuItemId["claimsReturns"] = "9";
  AccountMenuItemId["accountSettings"] = "10";
  AccountMenuItemId["preferenceSettings"] = "11";
  AccountMenuItemId["userManagement"] = "12";
  AccountMenuItemId["switchAccounts"] = "13";
  AccountMenuItemId["logOut"] = "14";
  AccountMenuItemId["documentCenter"] = "17";
  AccountMenuItemId["creditApplication"] = "18";
  AccountMenuItemId["adminPortal"] = "20";
  AccountMenuItemId["exitShadowMode"] = "21";
})(AccountMenuItemId || (exports.AccountMenuItemId = AccountMenuItemId = {})); // Note If any of these change,please make corresponding changes
// Menu.content file, for language support


var AccountMenuItemLabel;

(function (AccountMenuItemLabel) {
  AccountMenuItemLabel["dashboard"] = "Dashboard";
  AccountMenuItemLabel["orders"] = "Orders";
  AccountMenuItemLabel["subscribeSave"] = "Subscribe & Save";
  AccountMenuItemLabel["shoppingList"] = "Shopping Lists";
  AccountMenuItemLabel["quotes"] = "Quotes";
  AccountMenuItemLabel["invoices"] = "Invoices";
  AccountMenuItemLabel["myResources"] = "My Resources";
  AccountMenuItemLabel["reports"] = "Reports";
  AccountMenuItemLabel["claimsReturns"] = "Claims & Returns";
  AccountMenuItemLabel["accountSettings"] = "Account Settings";
  AccountMenuItemLabel["preferenceSettings"] = "Preferences & Settings";
  AccountMenuItemLabel["userManagement"] = "User Management";
  AccountMenuItemLabel["switchAccounts"] = "Switch Accounts";
  AccountMenuItemLabel["logOut"] = "Log Out";
  AccountMenuItemLabel["documentCenter"] = "Document Center";
  AccountMenuItemLabel["creditApplication"] = "Credit Application";
  AccountMenuItemLabel["adminPortal"] = "Admin Portal";
  AccountMenuItemLabel["exitShadowMode"] = "Return to Normal";
})(AccountMenuItemLabel || (exports.AccountMenuItemLabel = AccountMenuItemLabel = {}));

var AccountMenuItemIcon;

(function (AccountMenuItemIcon) {
  AccountMenuItemIcon["dashboard"] = "grid";
  AccountMenuItemIcon["orders"] = "layer-group";
  AccountMenuItemIcon["subscribeSave"] = "location-arrow";
  AccountMenuItemIcon["shoppingList"] = "bars";
  AccountMenuItemIcon["quotes"] = "bookmark";
  AccountMenuItemIcon["invoices"] = "briefcase";
  AccountMenuItemIcon["myResources"] = "person";
  AccountMenuItemIcon["reports"] = "file-cabinet";
  AccountMenuItemIcon["claimsReturns"] = "list-group";
  AccountMenuItemIcon["accountSettings"] = "gear";
  AccountMenuItemIcon["preferenceSettings"] = "gear";
  AccountMenuItemIcon["userManagement"] = "person";
  AccountMenuItemIcon["switchAccounts"] = "swap";
  AccountMenuItemIcon["logOut"] = "leave";
  AccountMenuItemIcon["documentCenter"] = "folder";
  AccountMenuItemIcon["creditApplication"] = "tachometer-slow";
  AccountMenuItemIcon["adminPortal"] = "check-complete";
  AccountMenuItemIcon["exitShadowMode"] = "revert";
})(AccountMenuItemIcon || (exports.AccountMenuItemIcon = AccountMenuItemIcon = {}));

var AccountMenuItemUrl;

(function (AccountMenuItemUrl) {
  AccountMenuItemUrl["dashboard"] = "/dashboard";
  AccountMenuItemUrl["orders"] = "/dashboard/orders";
  AccountMenuItemUrl["subscribeSave"] = "";
  AccountMenuItemUrl["shoppingList"] = "/dashboard/shopping-lists";
  AccountMenuItemUrl["quotes"] = "/dashboard/quotes";
  AccountMenuItemUrl["invoices"] = "/dashboard/invoices";
  AccountMenuItemUrl["myResources"] = "";
  AccountMenuItemUrl["reports"] = "/dashboard/reports";
  AccountMenuItemUrl["claimsReturns"] = "";
  AccountMenuItemUrl["accountSettings"] = "/dashboard/account-settings";
  AccountMenuItemUrl["preferenceSettings"] = "";
  AccountMenuItemUrl["userManagement"] = "/dashboard/user-management";
  AccountMenuItemUrl["switchAccounts"] = "";
  AccountMenuItemUrl["logOut"] = "";
  AccountMenuItemUrl["documentCenter"] = "";
  AccountMenuItemUrl["creditApplication"] = "/credit-application";
  AccountMenuItemUrl["adminPortal"] = "";
  AccountMenuItemUrl["exitShadowMode"] = "";
})(AccountMenuItemUrl || (exports.AccountMenuItemUrl = AccountMenuItemUrl = {}));